import React, { useState } from 'react';

import { Helmet } from 'react-helmet';

import Header from 'components/Headers/Header';
import Navigation from 'components/Navbars/Navigation';
import MainVisual from './components/MainVisual';
import About from './components/About';
import Poster from './components/Poster';
import Service from './components/Service';
import Information from './components/Information';
import Reservation from './components/Reservation';
import ContactUs from './components/ContactUs';
import Footer from 'components/Footers/Footer';
import ReservationModal from './components/ReservationModal';

function Main() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);  // 시설 예약 모달창 띄우고 닫는 state
  const [isStarted, setIsStarted] = useState(true);

  return (
    <>
      <Helmet>
        <title>공유디자이너랩</title>
      </Helmet>
      <Header setIsPopupOpen={setIsPopupOpen} isStarted={isStarted} />
      <aside id="navigation">
        <Navigation isStarted={isStarted} setIsStarted={setIsStarted} />
      </aside>
      <MainVisual />
      <div id="about-container">
        <About />
        <Poster />
      </div>
      <div id="services-container">
        <Service />
        <Information />
      </div>
      <Reservation setIsPopupOpen={setIsPopupOpen} />
      <ContactUs />
      <Footer />
      {isPopupOpen && (
        <ReservationModal
          isPopupOpen={isPopupOpen}
          setIsPopupOpen={setIsPopupOpen}
        />
      )}
    </>
  );
}

export default Main;
